﻿import isLocalhost from '../lib/isLocalhost';

const baseUrl = isLocalhost ? 'https://localhost:51595' : '';

export default baseUrl;
